import React, { FC } from 'react'

import { Table as BaseTable } from 'mf-ui-components'

import { BaseBlockProps } from '../../../../types/BaseBlockProps'
import { TableRecord } from './types'
import { TableWrapper } from './Table.styles'
import { parseData, parseHeaders } from './utils'

type Props = BaseBlockProps & { headers: string; data: string }

export const Table: FC<Props> = ({
  id,
  headers,
  data,
  hiddenAt,
  marginBottom,
}) => {
  const parsedHeaders = parseHeaders(headers)
  const parsedData = parseData(data, parsedHeaders)

  return (
    <TableWrapper hiddenAt={hiddenAt} marginBottom={marginBottom}>
      <BaseTable
        id={id}
        headers={parsedHeaders}
        data={parsedData}
        isHighlight={(item: TableRecord) => item.marked}
      />
    </TableWrapper>
  )
}
